import { FC } from 'react'
import { Information } from 'graphql/types'
import AboutComponent, {
  TProps as TAboutProps,
} from 'pages/regioes-atendidas/components/About'

export type TProps = {
  text?: Information['description']
  location: string
} & Pick<TAboutProps, 'showMore'>

const About: FC<TProps> = ({ location, text, showMore }) => {
  if (!text) return null
  const aboutParagraphs = text
    .split('\n')
    .filter((paragraph) => paragraph !== '')

  return (
    <AboutComponent
      title={`Sobre ${location}`}
      paragraphs={aboutParagraphs}
      showMore={showMore}
    />
  )
}

export default About
